import React, { useEffect, useMemo, useState } from 'react';
import { deletePost, loadPosts } from 'cms/utils/Network';
import { buildPaginationItems } from 'cms/utils/cmsPagination';

import TalentName from 'cms/components/TalentName';
import LanguageName from 'cms/components/LanguageName';
import { isAdmin } from 'cms/utils';
import UserName from 'cms/components/UserName';
import PostsFilterWidget from './PostsFilterWidget';

export default function PostsContent({ page, urlParams }) {
    const currentPage = Number(page) || 1;
    const filterQuery = useMemo(() => window.location.search, []);
    const [loading, setLoading] = useState(0);
    const [pageloading, setPageLoading] = useState(false);
    const [posts, setPosts] = useState(null);
    const [posts_count, setPostsCount] = useState(null);
    const [show_filter, setShowFilter] = useState(false);
    const [show_delete, setShowDelete] = useState(false);
    const [pages, setPages] = useState(null);
    const [filter_title, setFilterTitle] = useState('');
    const [filter_category, setFilterCategory] = useState('');
    const [filter_talent, setFilterTalent] = useState(null);
    const [filter_language, setFilterLanguage] = useState(null);

    useEffect(() => {
        setPageLoading(true);
        getPosts();
        setFilterTitle(urlParams.get('title'));
        setFilterCategory(urlParams.get('category'));
        setFilterTalent(urlParams.get('talent'));
        setFilterLanguage(urlParams.get('language'));
    }, []);

    function getPosts() {
        loadPosts(filterQuery, currentPage).then((data) => {
            if (data.results) {
                setPosts(data.results);
            }
            const totalCount = Number(data.count) || 0;
            setPostsCount(totalCount);
            if (totalCount > 0) {
                const pageCount =
                    totalCount % 10 === 0 ? parseInt(totalCount / 10, 10) : parseInt(totalCount / 10, 10) + 1;
                setPages(range(1, pageCount));
            } else {
                setPages([]);
            }
            setPageLoading(false);
        });
    }

    function range(start, end) {
        return Array.apply(0, Array(end))
            .map((element, index) => index + start);
    }

    const handleDelete = (id) => {
        setLoading(id);
        deletePost(id).then(() => {
            getPosts();
        });
    };

    const showDelete = (e) => {
        e.preventDefault();
        setShowDelete(!show_delete);
    };

    const showFilters = (e) => {
        e.preventDefault();
        setShowFilter(!show_filter);
    };

    const hasActiveFilters = !!(
        filter_title ||
        filter_category ||
        filter_talent ||
        filter_language
    );
    const filterPanelVisible = show_filter || hasActiveFilters;

    const onValue = (value, name) => {
        switch (name) {
            case 'category':
                setFilterCategory(value);
                break;
            case 'talent':
                setFilterTalent(value);
                break;
            case 'language':
                setFilterLanguage(value);
                break;
            default:
                break;
        }
    };

    const onChange = (e) => {
        switch (e.target.name) {
            case 'title':
                setFilterTitle(e.target.value);
                break;
            default:
                break;
        }
    };

    const totalPages = pages?.length || 0;
    const canGoPrev = totalPages > 0 && currentPage > 1;
    const canGoNext = totalPages > 0 && currentPage < totalPages;
    const queryString = urlParams.toString();
    const qs = queryString ? `?${queryString}` : '';
    const paginationItems = useMemo(() => {
        if (!totalPages) return [];
        return buildPaginationItems(currentPage, totalPages);
    }, [currentPage, totalPages]);

    return (
        <>
            <div className="content-wrapper">
                <section className="content">
                    <div className="container-fluid" style={{ maxWidth: '1400px' }}>
                        <div className="row users-filter-page-row">
                            <div className="col-md-12 users-filter-page-col">
                                <PostsFilterWidget
                                    visible={filterPanelVisible}
                                    filter_title={filter_title}
                                    filter_talent={filter_talent}
                                    filter_language={filter_language}
                                    onValue={onValue}
                                    onChange={onChange}
                                />
                                <div className="box box-primary mt-0 border-top-0 ">
                                    <div className="box-header with-border">
                                        <h3 className="box-title">
                                            All posts
                                            {posts_count != null && (
                                                <span style={{ fontSize: 11, marginLeft: '0.35em' }}>
                                                    ({posts_count})
                                                </span>
                                            )}
                                        </h3>
                                        <a href="/cms/post" title="Add New" className="btn btn-cm margin-r-5 pull-right">
                                            <i className="fa fa-plus"></i>
                                        </a>
                                        <button
                                            type="button"
                                            title="Filters"
                                            className="btn btn-cm margin-r-5 pull-right"
                                            onClick={showFilters}
                                        >
                                            <i className="fa fa-filter"></i>
                                        </button>
                                        <button
                                            type="button"
                                            title="Show Delete Button"
                                            className="btn btn-cm margin-r-5 pull-right"
                                            onClick={showDelete}
                                        >
                                            <i className="fa fa-trash"></i>
                                        </button>
                                    </div>
                                    <div className="box-body no-padding">
                                        <table
                                            id="example1"
                                            className={`table table-striped cms-draggable-list-rows cms-posts-table mb-0${pageloading ? ' opacity-70' : ''}`}
                                        >
                                            <thead>
                                                <tr>
                                                    <th>Title</th>
                                                    <th>Talent</th>
                                                    <th>Language</th>
                                                    {isAdmin() && <th>Author</th>}
                                                    <th>Date</th>
                                                    <th></th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {posts &&
                                                    posts.map((item) => (
                                                        <tr key={item.id} className={loading === item.id ? 'loading' : ''}>
                                                            <td>
                                                                <p className="mb-0 kfont">
                                                                    <a href={`/cms/post/${item.id}`} className="link-color">
                                                                        {item.title}
                                                                    </a>
                                                                </p>
                                                            </td>
                                                            <td>
                                                                <a href={`/cms/posts?talent=${item.talent}`}>
                                                                    <TalentName id={item.talent} />
                                                                </a>
                                                            </td>
                                                            <td>
                                                                <a href={`/cms/posts?language=${item.language}`}>
                                                                    <LanguageName id={item.language} />
                                                                </a>
                                                            </td>
                                                            {isAdmin() && (
                                                                <td>
                                                                    <a href={`/cms/user/${item.user}`}>
                                                                        <UserName id={item.user} />
                                                                    </a>
                                                                </td>
                                                            )}
                                                            <td>{(item.created_at || '').split(/[T ]/)[0]}</td>
                                                            <td className="cms-posts-actions-cell">
                                                                <div className="btn-group cms-posts-actions-group">
                                                                    {show_delete && (
                                                                        <>
                                                                            <button
                                                                                type="button"
                                                                                onClick={() => {
                                                                                    if (
                                                                                        window.confirm(
                                                                                            'Are you sure you wish to delete this item?'
                                                                                        )
                                                                                    ) {
                                                                                        handleDelete(item.id);
                                                                                    }
                                                                                }}
                                                                                className="btn btn-cm btn-sm"
                                                                            >
                                                                                <i className="fa fa-trash"></i>
                                                                            </button>
                                                                            <a
                                                                                href={`/cms/post/${item.id}`}
                                                                                className="btn btn-cm btn-sm"
                                                                            >
                                                                                <i className="fa fa-edit"></i>
                                                                            </a>
                                                                        </>
                                                                    )}
                                                                    {!show_delete && (
                                                                        <a
                                                                            href={`/cms/post/${item.id}`}
                                                                            className="btn btn-cm btn-sm"
                                                                        >
                                                                            <i className="fa fa-edit"></i>
                                                                        </a>
                                                                    )}
                                                                </div>
                                                            </td>
                                                        </tr>
                                                    ))}
                                            </tbody>
                                        </table>
                                        {!posts?.length && !pageloading && (
                                            <div className="padding-10 text-muted">No posts found.</div>
                                        )}
                                    </div>
                                </div>
                                {pages && pages.length > 1 && (
                                    <ul className="pagination cms-pagination m-0 float-right">
                                        <li className={`page-item${!canGoPrev ? ' disabled' : ''}`}>
                                            <a
                                                className="page-link"
                                                href={canGoPrev ? `/cms/posts/${currentPage - 1}${qs}` : '#'}
                                                onClick={!canGoPrev ? (e) => e.preventDefault() : undefined}
                                                aria-disabled={!canGoPrev}
                                            >
                                                «
                                            </a>
                                        </li>
                                        {paginationItems.map((entry, idx) => (
                                            <li
                                                key={entry === 'ellipsis' ? `e-${idx}` : entry}
                                                className="page-item"
                                            >
                                                {entry === 'ellipsis' ? (
                                                    <span
                                                        className="page-link disabled"
                                                        style={{ border: 'none', background: 'transparent' }}
                                                    >
                                                        …
                                                    </span>
                                                ) : (
                                                    <a
                                                        className={
                                                            entry === currentPage ? 'page-link active' : 'page-link'
                                                        }
                                                        href={`/cms/posts/${entry}${qs}`}
                                                    >
                                                        {entry}
                                                    </a>
                                                )}
                                            </li>
                                        ))}
                                        <li className={`page-item${!canGoNext ? ' disabled' : ''}`}>
                                            <a
                                                className="page-link"
                                                href={canGoNext ? `/cms/posts/${currentPage + 1}${qs}` : '#'}
                                                onClick={!canGoNext ? (e) => e.preventDefault() : undefined}
                                                aria-disabled={!canGoNext}
                                            >
                                                »
                                            </a>
                                        </li>
                                    </ul>
                                )}
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        </>
    );
}
